import {createSelector} from 'reselect'
import {UserManagementConstants} from "../../../constants"
import {isLVTEnabled, isOVREnabled, selectFeatures} from "../../../features/selectors"
import {isEnabled} from "../../../features/utils"
import {Feature} from "../../../features/constants"
import {getUserManagementData} from '../../../administration/userManagement/common/selectors'

export const getUserDataState = state => state.panels.user.userData

export const getPassword = state => getFullUserInfo(state).password

export const getPasswordCopy = state => getFullUserInfo(state).retypedPassword

export const getFullUserInfo = state => getUserDataState(state).fullUserInfo

export const getUserGroupRowData = state => getUserDataState(state).userGroupRowData
export const getTimeZoneGroupRowData = state => getUserDataState(state).timeZoneGroupRowData

export const getExtendedData = state => getUserDataState(state).extendedData

export const getUserManagementAssignmentsData = state => getUserDataState(state).userManageAssignmentsData

export const getUserPanelErrors = state => getUserDataState(state).providerErrors

export const getUserPanelPasswordValidationResult = state => getUserDataState(state).passwordValidationResult

export const getAllUsers = state => getUserDataState(state).allUsers

export const getUserPanelHasLeavesOrTTBeforeNewHireDateError = state => getUserDataState(state).hasLeavesOrTTBeforeNewHireDateError

export const getManagementAssignmentsCounters = state => getUserDataState(state).managementAssignmentsCounters

export const getManagementAssignmentsSelection = state => getUserManagementAssignmentsData(state).managementAssignmentsSelection

export const getUserTeamAssignmentsData = state => getUserDataState(state).userTeamAssignmentsData

export const getUserRights = state => getFullUserInfo(state).accessRights

export const getAllApprovers = state => getUserDataState(state).allApprovers

export const areManagementAssignmentsCountersLoaded = createSelector(
    getManagementAssignmentsCounters,
    (counters) => counters.loaded
)

export const getUserRatesValidationData = createSelector(
    getFullUserInfo,
    getUserManagementData,
    isLVTEnabled,
    isOVREnabled,
    (fullUserInfo, userManagementData, isLVTEnabled, isOVREnabled) => {
        return {
            leaveTypesEnabled: isLVTEnabled && userManagementData.activeLeaveTypes && userManagementData.activeLeaveTypes.length > 0,
            overtimeEnabled: isOVREnabled && fullUserInfo.overtimeLevel !== UserManagementConstants.OVERTIME_OFF
        }
    }
)

export const getUserDataWithAdditionalData = createSelector(
    getUserDataState,
    selectFeatures,
    (userDataState, features) => {
        return {
            ...userDataState,
            isUGREnabled: isEnabled(features, Feature.UGR),
            isTZGEnabled: isEnabled(features, Feature.TZG),
            isURAEnabled: isEnabled(features, Feature.URA),
            isTTAEnabled: isEnabled(features, Feature.TTA),
            isBTYEnabled: isEnabled(features, Feature.BTY),
            isLTTEnabled: isEnabled(features, Feature.LTT),
            isPTOEnabled: isEnabled(features, Feature.PTO),
            isSDBEnabled: isEnabled(features, Feature.SDB),
            isOVREnabled: isEnabled(features, Feature.OVR),
        }
    }
)

export const getWorkSchedule = createSelector(
    getFullUserInfo,
    (fullUserInfo) => fullUserInfo.workSchedule
)

export const getCurrentTimeInUserTimeZone = createSelector(
    getExtendedData,
    (extendedData) => extendedData.currentTime
)

export const getUserFML = createSelector(
    getFullUserInfo,
    (fullUserInfo) => {
        return fullUserInfo ? {
            firstName: fullUserInfo.firstName,
            middleInitial: fullUserInfo.middleInitial,
            lastName: fullUserInfo.lastName,
        } : {}
    }
)



// WEBPACK FOOTER //
// ./web/js/panels/user/userData/selectors.js